import * as React from "react";
import * as cn from "classnames/bind";
import * as styles from "./controls-container.css";
import { useResources } from "contexts/resource-context";

const cx = cn.bind(styles);

type ControlsContainerProps = {
    Title: string;
    children: React.ReactNode;
};

const componentContainerCn = () =>
    cx({
        componentContainer: true,
    });

const ControlsContainer: React.SFC<ControlsContainerProps> = (props) => {
    const resources = useResources();

    return (
        <div className={componentContainerCn()}>
            {props.Title !== "" && (
                <p>
                    <strong>
                        {resources[props.Title] !== undefined
                            ? resources[props.Title]
                            : props.Title}
                    </strong>
                </p>
            )}
            {props.children}
        </div>
    );
};

export default ControlsContainer;
